import React from 'react';

function Copyright() {
    return (
        <div className="copyright">&copy; TOKYO FABRIC INDUSTRY CO., LTD. All Rights Reserved.</div>
    )
}

export default Copyright;
